import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiQrCode, FiArrowRight, FiZap, FiPlay } = FiIcons;

export default function Hero() {
  return (
    <section className="relative pt-40 pb-24 md:pt-64 md:pb-48 overflow-hidden bg-mesh">
      {/* Dynamic Animated Background Elements */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-indigo-600/20 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[120px]" />

      <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-white/5 border border-white/10 text-indigo-400 text-xs font-black uppercase tracking-[0.3em] mb-10 shadow-2xl"
        >
          <SafeIcon icon={FiZap} className="animate-bounce" />
          The Future of Event Curation
        </motion.div>

        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-6xl md:text-9xl font-black tracking-tighter mb-8 leading-[0.85]"
        >
          Capture the <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-purple-500 to-pink-500 animate-gradient-x">Unseen Magic.</span>
        </motion.h1>

        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-lg md:text-2xl text-slate-400 max-w-3xl mx-auto mb-14 font-light leading-relaxed"
        >
          Collect high-res photos and 4K videos from every guest at your <b>concert, wedding,</b> or <b>corporate gala</b>. One QR code. Instant uploads. Zero friction.
        </motion.p>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-5 justify-center mb-24"
        >
          <button className="group relative bg-white text-black px-12 py-5 rounded-2xl text-lg font-black hover:bg-indigo-500 hover:text-white transition-all shadow-2xl shadow-indigo-500/20 flex items-center justify-center gap-3 overflow-hidden">
            <span className="relative z-10">Create Your Event</span>
            <SafeIcon icon={FiArrowRight} className="relative z-10 group-hover:translate-x-2 transition-transform" />
          </button>
          <button className="glass-card text-white px-12 py-5 rounded-2xl text-lg font-black hover:bg-white/10 transition-all flex items-center justify-center gap-3">
            <SafeIcon icon={FiPlay} />
            Watch Demo
          </button>
        </motion.div>

        {/* Hero Visual: High-Impact Video/Image Mockup */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="relative max-w-6xl mx-auto"
        >
          <div className="aspect-[21/9] rounded-[3rem] overflow-hidden border border-white/10 shadow-[0_0_150px_rgba(99,102,241,0.3)] bg-zinc-900 group">
            <img 
              src="https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?auto=format&fit=crop&q=80&w=1600" 
              alt="Live Concert Crowd with Lights" 
              className="w-full h-full object-cover transition-transform duration-[20s] group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
            
            {/* Overlay UI */}
            <div className="absolute bottom-10 left-10 flex items-center gap-6">
              <div className="w-20 h-20 rounded-2xl bg-white flex items-center justify-center p-2 shadow-2xl animate-float">
                <SafeIcon icon={FiQrCode} className="w-14 h-14 text-black" />
              </div>
              <div className="text-left">
                <p className="text-sm font-black text-indigo-400 uppercase tracking-widest mb-1">Live Feed</p>
                <h4 className="text-2xl font-bold text-white">Coachella Main Stage '24</h4>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}